const requirements: string[] = ['Symbol', 'Proxy', 'URLSearchParams'];
export const isOldBrowser = !requirements.every(key => key in window);
